import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import auth from "../../services/authService";
import Joi from "joi-browser";
import { toast, cssTransition } from "react-toastify";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import { addReviewNotes, getAllNotes, getNotesAddedStatus, loadAllReviewNotes, reviewNotesAdded } from "../../app/store/reviewNotes";
import { getCurrentUser } from "../../app/store/auth";
import { allowFormLibraryEdit, formLibraryEditAllowed, getFormLibraryEditStatus } from "../../app/store/forms";

const AddEditNotes = (props) => {
  const { noteShowHide, handleNoteShowHide, notesType,
    candidateObj, timeLogObj, selectedObj } = props;

  const [allNotes, setAllNotes] = useState([]);
  const [notes, setNotes] = useState("");
  const [btnAddedStatus, setBtnAddedStatus] = useState(false);
  const [expandedNotes, setExpandedNotes] = useState({});

  const allNotesSelector = useSelector(getAllNotes);
  const notesAddedStatusSelector = useSelector(getNotesAddedStatus);
  const formLibraryEditStatusSelector = useSelector(getFormLibraryEditStatus);

  const dispatch = useDispatch();

  const currentUser = getCurrentUser();

  useEffect(() => {
    if (candidateObj?.performerid) {
      dispatch(loadAllReviewNotes(notesType, candidateObj.performerid))
    }
  }, [candidateObj]);

  useEffect(() => {
    if (allNotesSelector.length > 0 && timeLogObj?.id > 0) {
      let filterNotes = allNotesSelector;

      if (timeLogObj?.id > 0)
        filterNotes = filterNotes.filter((x) => x.ciid === timeLogObj.id);

      setAllNotes(filterNotes);
      setNotes("");
      if (btnAddedStatus) {
        setBtnAddedStatus(false);
        handleNoteShowHide("save", "");
      }
    }
  }, [allNotesSelector]);

  useEffect(() => {
    if (allNotesSelector.length > 0 && timeLogObj?.id > 0) {
      let filterNotes = allNotesSelector;

      if (timeLogObj?.id > 0)
        filterNotes = filterNotes.filter((x) => x.ciid === timeLogObj.id);

      setAllNotes(filterNotes);
      setNotes("");

    }
  }, [timeLogObj])

  const doSubmit = async () => {
    if (notesType === "formEditReq") {
      const result = await getConfirmAlert("Warning", "Are you sure you want to give permission to Edit this Form?", "warning");
      if (result.isConfirmed) {
        dispatch(allowFormLibraryEdit(selectedObj.id, 1, notes));
      }
    } else {
      const frmData = new FormData();
      frmData.append("comment", notes);
      frmData.append("type", notesType);
      frmData.append("userId", currentUser.id);
      frmData.append("performerId", candidateObj.performerid);
      if (timeLogObj?.id > 0)
        frmData.append("ciid", timeLogObj.id);

      const result = await getConfirmAlert("Warning", "Are you sure you want to add this Note?", "warning");
      if (result.isConfirmed)
        dispatch(addReviewNotes(frmData));
    }
  };

  useEffect(() => {
    if (notesAddedStatusSelector) {
      getAlert("", "Note Added Successfully", "success");
      setBtnAddedStatus(true);
      if (candidateObj?.performerid) {
        dispatch(loadAllReviewNotes(notesType, candidateObj.performerid));
      }
      dispatch(reviewNotesAdded(false));
    }
  }, [notesAddedStatusSelector]);

  useEffect(() => {
    if (formLibraryEditStatusSelector) {
      getAlert("", "Allowed Successfully", "success");
      dispatch(formLibraryEditAllowed(false));
      handleNoteShowHide("save", "");
    }
  }, [formLibraryEditStatusSelector]);


  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-notes-modal.modal-dialog {
          transform: scale(0.96) !important;
          transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-notes-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-notes-modal {
          max-width: 720px !important;
          width: 100% !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .wf-notes-modal .modal-content {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-notes-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 14px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-notes-modal .modal-header::before {
          display: none !important;
        }

        .wf-notes-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          width: 100% !important;
        }

        .wf-notes-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          width: 100% !important;
        }

        .wf-notes-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-notes-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }

        .wf-notes-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 17px !important;
          font-weight: 600 !important;
          line-height: 1.25 !important;
        }

        .wf-notes-modal .rt-header-icon {
          width: 38px !important;
          height: 38px !important;
          min-height: 38px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
        }

        .wf-notes-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
        }

        .wf-notes-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }

        .wf-notes-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-notes-modal .rt-modal-desc i {
          color: #64748b !important;
        }

        .wf-notes-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          outline: none !important;
        }
        .wf-notes-modal .rt-action-btn:hover {
          color: #ef4444 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .wf-notes-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(90vh - 140px) !important;
          overflow-y: auto !important;
        }

        .wf-notes-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 14px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }

        .wf-notes-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 14px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-notes-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
        }

        .wf-notes-modal .wf-btn-send {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 7px 16px !important;
          border-radius: 0 !important;
          border: 1px solid #2563eb !important;
          background: #2563eb !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-notes-modal .wf-btn-send:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .wf-notes-modal .wf-btn-send:active {
          transform: scale(0.97) !important;
        }
        .wf-notes-modal .wf-btn-send:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }

        /* Notes Table Container */
        .wf-notes-modal .wf-notes-table-wrap {
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          overflow: hidden !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
          max-height: 280px !important;
          overflow-y: auto !important;
          margin-bottom: 20px !important;
          background: #ffffff !important;
        }

        .wf-notes-modal .wf-notes-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
          font-size: 13.5px !important;
          margin: 0 !important;
        }

        .wf-notes-modal .wf-notes-table thead th {
          position: sticky !important;
          top: 0 !important;
          background: #f8fafc !important;
          color: #475569 !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          font-size: 11px !important;
          padding: 10px 14px !important;
          border-bottom: 1px solid #e2e8f0 !important;
          z-index: 10 !important;
        }

        .wf-notes-modal .wf-notes-table tbody tr {
          transition: background-color 0.15s ease !important;
        }

        .wf-notes-modal .wf-notes-table tbody tr:hover {
          background-color: #f8fafc !important;
        }

        .wf-notes-modal .wf-notes-table tbody td {
          padding: 12px 14px !important;
          vertical-align: top !important;
          border-bottom: 1px solid #f1f5f9 !important;
          color: #334155 !important;
        }

        .wf-notes-modal .wf-notes-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        .wf-notes-modal .wf-notes-date-cell {
          font-weight: 600 !important;
          color: #0f172a !important;
          font-size: 13px !important;
          white-space: nowrap !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
        }

        .wf-notes-modal .wf-notes-date-cell i {
          color: #2563eb !important;
          font-size: 12px !important;
        }

        .wf-notes-modal .wf-notes-time-cell {
          font-weight: 500 !important;
          color: #64748b !important;
          font-size: 11.5px !important;
          white-space: nowrap !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
        }

        .wf-notes-modal .wf-notes-time-cell i {
          color: #64748b !important;
          font-size: 11px !important;
        }

        .wf-notes-modal .wf-notes-comment-wrap {
          position: relative !important;
        }

        .wf-notes-modal .wf-notes-comment {
          white-space: pre-wrap !important;
          word-break: break-word !important;
          line-height: 1.55 !important;
          color: #0f172a !important;
          font-weight: 400 !important;
          font-size: 13.5px !important;
        }

        .wf-notes-modal .wf-notes-comment.wf-clickable {
          cursor: pointer !important;
        }

        .wf-notes-modal .wf-notes-comment.wf-clickable:hover {
          color: #2563eb !important;
        }

        .wf-notes-modal .wf-notes-expand-hint {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          color: #2563eb !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          margin-top: 4px !important;
          background: #eff6ff !important;
          padding: 2px 6px !important;
          border-radius: 0 !important;
          border: 1px solid #bfdbfe !important;
        }

        .wf-notes-modal .wf-notes-author-cell {
          display: flex !important;
          align-items: flex-start !important;
          gap: 10px !important;
          min-width: 180px !important;
        }

        .wf-notes-modal .wf-notes-avatar {
          width: 30px !important;
          height: 30px !important;
          border-radius: 0 !important;
          background: #f1f5f9 !important;
          color: #0f172a !important;
          font-weight: 700 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 12px !important;
          border: 1px solid #cbd5e1 !important;
          flex-shrink: 0 !important;
          margin-top: 1px !important;
        }

        .wf-notes-modal .wf-notes-author-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          white-space: nowrap !important;
        }

        .wf-notes-modal .wf-notes-author-name {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #0f172a !important;
        }

        .wf-notes-modal .wf-notes-author-email {
          font-size: 11px !important;
          color: #64748b !important;
          font-weight: 400 !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          line-height: 1 !important;
          white-space: nowrap !important;
        }

        .wf-notes-modal .wf-notes-author-email i {
          color: #64748b !important;
          font-size: 10px !important;
          flex-shrink: 0 !important;
        }

        .wf-notes-modal .wf-notes-author-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 2px 6px !important;
          border-radius: 0 !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #f8fafc !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
          margin-top: 3px !important;
          width: fit-content !important;
        }

        .wf-notes-modal .wf-textarea-label {
          display: block !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          margin-bottom: 6px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
        }

        .wf-notes-modal .wf-textarea-input {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 10px 14px !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
          color: #0f172a !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          min-height: 76px !important;
          resize: vertical !important;
          outline: none !important;
        }

        .wf-notes-modal .wf-textarea-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }
        
        .wf-notes-modal .wf-textarea-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }
` }} />
      <Modal show={noteShowHide} size="lg" dialogClassName="wf-notes-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-commenting-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{notesType === "formEditReq" ? "Allow Edit Form" : "Notes Log"}</span>
                      <span className="rt-modal-title-badge">{notesType === "formEditReq" ? "Request" : "Comments"}</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> View, add, or manage review comments and notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleNoteShowHide("", "")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            {notesType !== "formEditReq" && (
              <div className="col-md-12">
                {allNotes.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "40px 10px", color: "#64748b", background: "#f8fafc", borderRadius: "12px", border: "1px dashed #cbd5e1", marginBottom: "20px" }}>
                    <div style={{ fontSize: "24px", marginBottom: "8px", color: "#94a3b8" }}><i className="fa fa-comment-o" /></div>
                    <div style={{ fontWeight: 700, fontSize: "14px", color: "#475569" }}>No Notes Yet</div>
                    <div style={{ fontSize: "12.5px", color: "#94a3b8", marginTop: "2px" }}>Be the first to add a note below.</div>
                  </div>
                ) : (
                  <div className="wf-notes-table-wrap">
                    <table className="wf-notes-table">
                      <thead>
                        <tr>
                          <th style={{ width: "160px" }}>Date & Time</th>
                          <th style={{ width: "240px" }}>Added By</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                                                {allNotes.map((item, key) => {
                          const initials = item.performer ? item.performer.charAt(0).toUpperCase() : "N";

                          const metadataParts = [];
                          if (item.role) metadataParts.push(item.role);
                          if (item.department) metadataParts.push(item.department);
                          if (item.partner) metadataParts.push(item.partner);
                          const metadataStr = metadataParts.join(" • ");

                          const noteId = item.id || key;
                          const isExpanded = expandedNotes[noteId];
                          const shouldTruncate = item.comments && item.comments.length > 45;
                          const displayText = shouldTruncate && !isExpanded
                            ? `${item.comments.substring(0, 45)}...`
                            : item.comments;

                          return (
                            <tr key={noteId}>
                              <td>
                                <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                  <span className="wf-notes-date-cell">
                                    <Moment format="MMM Do YYYY">{item.dateTime}</Moment>
                                  </span>
                                  <span className="wf-notes-time-cell">
                                    <Moment format="h:mm a">{item.dateTime}</Moment>
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="wf-notes-author-cell">
                                  <div className="wf-notes-avatar">
                                    {initials}
                                  </div>
                                  <div className="wf-notes-author-info">
                                    <span className="wf-notes-author-name">{item.performer}</span>
                                    {item.email && (
                                      <span className="wf-notes-author-email">
                                        {item.email}
                                      </span>
                                    )}
                                    {metadataStr && (
                                      <span className="wf-notes-author-badge">
                                        {metadataStr}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="wf-notes-comment-wrap">
                                  <div
                                    className={`wf-notes-comment ${shouldTruncate ? "wf-clickable" : ""}`}
                                    title={item.comments}
                                    onClick={shouldTruncate ? () => setExpandedNotes(prev => ({ ...prev, [noteId]: !isExpanded })) : undefined}
                                  >
                                    {displayText}
                                  </div>
                                  {shouldTruncate && (
                                    <div
                                      className="wf-notes-expand-hint"
                                      onClick={() => setExpandedNotes(prev => ({ ...prev, [noteId]: !isExpanded }))}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className={`fa fa-chevron-${isExpanded ? "up" : "down"}`} />
                                      {isExpanded ? "Show less" : "Show more"}
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            <div className="col-md-12">
              <label htmlFor="notes" className="wf-textarea-label">New Note</label>
              <textarea
                cols={2}
                rows={2}
                className="form-control wf-textarea-input"
                id="notes"
                name="notes"
                placeholder="Type your notes or comments here..."
                value={notes}
                onChange={({ currentTarget }) => setNotes(currentTarget.value)}
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleNoteShowHide("", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-send"
            disabled={!notes}
            onClick={doSubmit}
          >
            <i className="fa fa-paper-plane" aria-hidden="true"></i> {notesType !== "formEditReq" ? "Send" : "Allow"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddEditNotes;
